import React, { useState, useRef } from "react";
import Slider from "react-slick";
import "../../assets/css/MiddOffer.css"; 
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import carpet from "../../assets/images/carpet-banner.jpg"

const images = [
  carpet,
  carpet,
];
const MiddHeroBanner = () => {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const slider1 = useRef(null);
  //   const slider2 = useRef(null);

  const mainSettings = {
    asNavFor: nav2,
    ref: (slider) => setNav1(slider),
    arrows: true,
    autoplay: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const thumbSettings = {
    asNavFor: nav1,
    ref: (slider) => setNav2(slider),
    slidesToShow: 4,
    swipeToSlide: true,
    focusOnSelect: true,
    arrows: false,
    infinite: true,
  };

  return (
    <div className="hero-banner">
      <Slider {...mainSettings} ref={slider1}>
        {images.map((img, index) => (
          <div key={index}>
            <img src={carpet} alt={`Banner ${index}`} style={{ width: "100%", height: "auto" }} />
          </div>
        ))}
      </Slider>

    {/* <div className="thumbnail-slider">
         <Slider {...thumbSettings} ref={slider2}>
          {images.map((img, index) => (
            <div key={index}>
              <img
                src={img}
                alt={`Thumbnail ${index}`}
                style={{
                  width: "100%",
                  height: "80px",
                  objectFit: "cover",
                  padding: "5px",
                  borderRadius: "4px",
                }}
              />
            </div>
          ))}
        </Slider>
      </div> */}

    </div>
  );
};
export default MiddHeroBanner;